import React from "react";
import { Button, useNotify, useRefresh } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import EditIcon from "@mui/icons-material/Edit";
import EmployeeInput from "server/components/Fields/EmployeeInput";
import { specialistRequests } from "api/specialistApi";

const UpdateSupervisorDialog = ({ specialistId }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async data => {
    const payload = {
      supervisorEmployeeId: data.supervisorEmployeeId,
    };
    await dataProvider.customRequest(specialistRequests.patchSupervisorForSpecialist(specialistId), payload, "PATCH");
    notify("Успешно редактиране на ръководител", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent={"Редакция на ръководител"}
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          startIcon={<EditIcon />}
          label="Редактирай"
          variant="contained"
        />
      }
    >
      <EmployeeInput
        source="supervisorEmployeeId"
        label="Ръководител"
      />
    </FormModal>
  );
};

export default UpdateSupervisorDialog;
